"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bankImportDecisionsSchema = exports.bankImportDecisionSchema = void 0;
const zod_1 = require("zod");
/** One user decision for a non-`alreadyImported` row — keyed by `dedupHash`
 * in the commit payload:
 *  - 'accept' (with `invoiceId`) records a payment against that invoice —
 *    for an 'auto' row this OVERRIDES the automatic match with a different
 *    invoice only if the user changed the dropdown; a row with no explicit
 *    decision at all keeps its 'auto' match by default (see
 *    BankImportService.commitImport).
 *  - 'ignore' records the transaction (so a later re-import still recognizes
 *    it as already-seen) but WITHOUT a payment. */
exports.bankImportDecisionSchema = zod_1.z.object({
    action: zod_1.z.enum(['accept', 'ignore']),
    invoiceId: zod_1.z.uuid('invoiceId invalid.').optional(),
});
/**
 * `POST /bank-import/commit` body's `decisions` field (sent as a JSON string
 * form field alongside the re-uploaded files — see BankImportController).
 * Validated only loosely here (a record of unknown-shaped entries), same
 * reasoning as `clientImportCommitSchema`: a single malformed entry must
 * become one `failed` row in `BankImportResult`, not reject the whole
 * request. `BankImportService.commitImport` re-validates each entry with
 * `bankImportDecisionSchema.safeParse` before acting on it.
 */
exports.bankImportDecisionsSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.unknown());
